import { UserLevel } from "./UserLevel";

export interface UserLevelDisplayItem {
  value: number;
  label: string;
}

export const UserLevelDisplay: UserLevelDisplayItem[] = [
  { value: UserLevel.MASTER, label: "Master" },
  { value: UserLevel.FULL, label: "Geral" },
  { value: UserLevel.ADMIN, label: "Administrador" },
  { value: UserLevel.OWNER, label: "Proprietário" },
  { value: UserLevel.USER, label: "Usuário básico" },
];
